import { ILineComposition } from '../models/quotations.models';

/**
 * Helpers shared by every surface that renders an order's line composition
 * (WB-8066): the orders list cell, the order detail header, the side-by-side
 * panel and the legacy orders list. Kept in one place so the four can never
 * disagree about what "lines" or "needs attention" means.
 */

/** Legacy per-order counts, used only until WB-8100 ships `line_composition`. */
export interface ILegacyLineCounts {
  total_order_lines?: number;
  nbr_products?: number;
}

/**
 * Number shown in the "Order lines" slot.
 *
 * Prefers the composition block. The fallbacks are ordered by how wrong they
 * are: `total_order_lines` is a real line count that merely omits unmatched
 * rows, while `nbr_products` is a distinct *product* count that happens to be
 * the only thing the list payload carries today. Both under-report, which is
 * the bug WB-8100 fixes -- they exist so the column is never blank in the
 * meantime.
 */
export function resolveLineCount(
  composition: ILineComposition | null | undefined,
  legacy?: ILegacyLineCounts,
): number {
  return composition?.total_lines ?? legacy?.total_order_lines ?? legacy?.nbr_products ?? 0;
}

/**
 * Lines the user still has to deal with: needs review *plus* unmatched, which
 * is what the amber badge counts. Returns 0 when there is nothing to flag —
 * that zero is what hides the badge.
 */
export function resolveAttentionCount(composition: ILineComposition | null | undefined): number {
  if (!composition) return 0;
  return (composition.lines_needing_review ?? 0) + (composition.unmatched_lines ?? 0);
}
